import { Controller } from '@hotwired/stimulus';

// Each profile section is its own React root listening for `tp:open-section`, so server-rendered
// markup opens one the same way the completion card does.
export default class extends Controller {
  open({ params: { section } }) {
    window.dispatchEvent(new CustomEvent('tp:open-section', { detail: section }));
  }
}
